import { render } from "./TheMyticketHeader.vue?vue&type=template&id=4152e746&scoped=true"
import script from "./TheMyticketHeader.vue?vue&type=script&lang=js"
export * from "./TheMyticketHeader.vue?vue&type=script&lang=js"

import "./TheMyticketHeader.vue?vue&type=style&index=0&id=4152e746&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4152e746"

export default script